import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { LabmoduleService } from '../../../services/labmodule.service';
import { FormsModule } from '@angular/forms';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'status-update-dialog',
  standalone: true,
  imports: [FormsModule, CommonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule],
  templateUrl: './status-update-dialog.component.html',
  styleUrl: './status-update-dialog.component.css'
})
export class StatusUpdateDialogComponent {
  status = '';

  comments = '';
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private dialogRef: MatDialogRef<StatusUpdateDialogComponent>,
    private labService: LabmoduleService
  ) { }
  ngOnInit() {
    console.log("StatusUpdateDialogComponent data", this.data);


    this.status =
      this.data.requisition.status || 'Open';

    this.comments =
      this.data.requisition.comments || '';
  }


  update() {

    const payload = {
      id: this.data.requisition.id,
      status: this.status,
      labcomments: this.comments
    };

    this.labService
      .updateRequisitionByLab(payload)
      .subscribe(() => {

        this.dialogRef.close(true);

      });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

}
